<template>
  <div id="app">
    <div class="head">
      <div class="contain">
        <div class="head_l">
          <a href="#" class="logo"><img src="./assets/logo.png"></a>
        </div>
        <div class="head_r">
          <a  href="https://www.jinshisong.com/zh-CN/download" class="download">
            <span style="margin-right:2px;">下载APP</span>
            <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="svg_f85js59">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5V13.5858L6.70711 9.29289C6.31658 8.90237 5.68342 8.90237 5.29289 9.29289C4.90237 9.68342 4.90237 10.3166 5.29289 10.7071L11.2929 16.7071C11.6834 17.0976 12.3166 17.0976 12.7071 16.7071L18.7071 10.7071C19.0976 10.3166 19.0976 9.68342 18.7071 9.29289C18.3166 8.90237 17.6834 8.90237 17.2929 9.29289L13 13.5858V5ZM5 18C4.44772 18 4 18.4477 4 19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19C20 18.4477 19.5523 18 19 18H5Z"></path>
            </svg>
          </a>
        </div>
      </div>
    </div>
    <div class="banner">
      <div class="contain">
        <a href="https://www.jinshisong.com">立即下单</a>
      </div>
    </div>
    <router-view/>
    <div class="foot">
      <div class="contain">
        <div class="foot_t">
          <img src="./assets/logo.png">
        </div>
        <div class="foot_b">
          <ul>
            <li><a href="https://jinshisong.com/zh-CN/legal/privacy-policy">隐私政策</a></li>
            <li><a href="https://jinshisong.com/zh-CN/legal/cookie-policy">Cookie政策</a></li>
            <li><a href="https://jinshisong.com/zh-CN/legal/terms-and-conditions">条款与条件</a></li>
          </ul>
          <ul>
            <li>版权所有©2011年至今 北京锦食送科技有限公司。保留所有权利。</li>
            <li><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502041137"><img src="./assets/miit_icon.png">京公安备11010502041137号</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a href="https://beian.miit.gov.cn/">京ICP备15060521号</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  padding: 0;
  margin:0;
}
a{text-decoration: none;color: #1f1f1f;}
li{list-style: none;}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  padding-top: 70px;
  /* padding-bottom: 272px; */
}
.contain{
  width: 1200px;
  margin: 0 auto;
}

.head{
  width: 100%;
  height: 70px;
  line-height: 70px;
  background: #ffffff;
  position: fixed;
  top:0;
  left:0;
  z-index: 10;
}
.head .contain{
  height: 70px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.logo img{
  width: 160px;
  display: block;
}
.download{
  background: #F9CB2D;
  border-radius: 8px;
  padding: 0 16px;
  height: 46px;
  color: #020001;
  font-size: 18px;
  display: flex;
  align-items: center;
}

.banner{
  background: url('./assets/banner.png') no-repeat;
  background-position: center center;
  background-size: cover;
  height: 500px;
  width: 100%;
  position: relative;
}
.banner a{
  position: absolute;
  bottom:60px;
  left:50%;
  margin-left: -144px;
  width: 288px;
  height: 88px;
  line-height: 88px;
  background: #FFFFFF;
  box-shadow: 0px 0px 9px 0px rgba(6, 0, 1, 0.2);
  border-radius: 20px;
  font-size: 36px;
  color: #F7CF49;
  text-align: center;
}

.foot{
  width: 100%;
  background: #fbfbfb;
  height: 200px;
  /* position: fixed;
  bottom: 0;
  left:0; */
  border-bottom: #F9CB2D 16px solid;
  font-size: 18px;
  z-index: 10;
}
.foot_t{
  padding-top: 10px;
  width: 100%;
  border-bottom: 1px solid #EFEFEF;
  margin-bottom: 20px;
}
.foot_t img{
  display: block;
  width: 200px;
}
.foot_b ul{
  display: flex;
  justify-content: space-between;
}
.foot_b ul li{
  display: flex;
  align-items: center;
  color: #999999;
}
.foot_b ul a{
  color: #1F1F1F;
  height: 40px;
  line-height: 40px;
}
.foot_b ul img{
  width: 18px;
  height: 18px;
  margin-right: 8px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue